(() => {
  const BLOCK = "azwr2anvyqlpjbfqlqaigenblock0eecc40f6nuyt";

  const rootSelector = `collection-carousel-${BLOCK}`;
  const trackSelector = `[class^="ai-collection-carousel__track-${BLOCK}"]`;

  function getRoot() {
    return document.querySelector(rootSelector) || document.querySelector(trackSelector);
  }

  async function ensureHoverImageForSlide(slide) {
    if (!slide || slide.dataset.aiHoverDone === "1") return;

    const handle = slide.getAttribute("handle");
    if (!handle) return;

    const wrap = slide.querySelector(`[class^="ai-collection-carousel__image-wrapper-${BLOCK}"]`);
    if (!wrap) return;

    const img1 = wrap.querySelector("img");
    if (!img1) return;

    slide.dataset.aiHoverDone = "1";

    wrap.style.position = "relative";
    wrap.classList.add("ai-hover-ready");
    img1.classList.add("ai-main-img");

    try {
      const r = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
      if (!r.ok) return;

      const p = await r.json();
      if (!p.images || p.images.length < 2) return;

      const img2 = document.createElement("img");
      img2.className = "ai-hover-img";
      img2.src = p.images[1];
      img2.alt = img1.alt || "";
      img2.loading = "lazy";

      const w = img1.getAttribute("width");
      const h = img1.getAttribute("height");
      if (w) img2.setAttribute("width", w);
      if (h) img2.setAttribute("height", h);

      img2.style.position = "absolute";
      img2.style.top = "0";
      img2.style.left = "0";
      img2.style.width = "100%";
      img2.style.height = "100%";
      img2.style.objectFit = "cover";
      img2.style.opacity = "0";
      img2.style.pointerEvents = "none";

      wrap.appendChild(img2);
    } catch (_) {
      return;
    }
  }

  function bind() {
    const root = getRoot();
    if (!root) return;

    const slideSelector = `[class^="ai-collection-carousel__slide-${BLOCK}"][handle]`;

    root.addEventListener(
      "mouseenter",
      (e) => {
        const slide = e.target.closest(slideSelector);
        if (!slide) return;
        ensureHoverImageForSlide(slide);
      },
      true
    );

    const mo = new MutationObserver(() => {
      root.querySelectorAll(slideSelector).forEach((s) => {
        // Alleen markeren dat we 'm kennen; echte fetch pas bij hover
        if (s.dataset.aiHoverSeen !== "1") s.dataset.aiHoverSeen = "1";
      });
    });

    mo.observe(root, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", bind);
})();